import { TMUIRichTextEditorStyles } from 'mui-rte';

export default (width?: string) =>
  ({
    overrides: {
      MUIRichTextEditor: {
        root: {
          backgroundColor: 'inherit',
          width: width || '100%',
          height: 'auto'
        },
        toolbar: {
          paddingLeft: '20px',
          display: 'none'
        }
      }
    }
  } as TMUIRichTextEditorStyles);
